<template>
  <section class="w-100 bg-licensed">
    <div class="w-100 h-100 mt-5 gradient-to-transparent d-flex align-items-center">
      <b-container>
        <b-row :style="topSpace" class="d-flex align-items-center">
          <b-col lg="6" class="text-left text-purple font-family-primary py-5 pr-5">
            <h1 class="font-weight-normal mb-4">
              Seja um franqueado
              <strong>VAAPTY</strong>
              <strong>Auto Trader</strong>
            </h1>
            <h5 class="font-weight-normal">
              Conquiste
              <strong>sua independência financeira</strong> com
              <strong>altos rendimentos</strong> intermediando venda de veículos.
              <br />
              <strong>Tenha um estoque virtual de veículos</strong> ilimitado e uma
              <strong>rede com mais de 6.000 compradores</strong> prontos para fazer a melhor oferta.
            </h5>
          </b-col>

          <b-col>
            <form-brookers
              id="form-brookers"
              class="d-flex align-items-center justify-content-center"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </section>
</template>

<script>
import FormBrookers from "@/components/FormBrookers.vue";
export default {
  components: {
    FormBrookers
  },
  props: {
    topSpace: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
section {
  min-height: 80vh;

  @media screen and (max-width: 992px) {
    min-height: auto;
  }
}

.bg-licensed {
  background-image: url("./../../assets/images/bg-pages/bg-licenciados.jpg");
  background-position: top right;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
